import { Switch, SwitchProps } from 'antd';
import React, { useContext } from 'react';
import { useFieldProperty } from '../hooks/field.hooks';
import { LogikFormItemContext } from './LogikFormItemBase';
import { useCustomFormItemErrorsAndWarnings } from '../hooks/form.hooks';

export type LogikSwitchProps = SwitchProps;

export const LogikSwitch = React.forwardRef<HTMLElement, LogikSwitchProps>(function LogikInput(
    { disabled, ...props }: LogikSwitchProps & React.RefAttributes<HTMLElement>,
    ref,
): JSX.Element {
    useCustomFormItemErrorsAndWarnings();
    const logikFormItemContext = useContext(LogikFormItemContext);
    const isEditable = useFieldProperty()(
        (f) => f.editable,
        logikFormItemContext?.logikName,
        logikFormItemContext?.index,
        logikFormItemContext?.setName,
    );

    return <Switch {...props} disabled={disabled || isEditable === 'false'} ref={ref} />;
});
